   
      const heroHomeVideo = $('.hero-home-video');
      const heroHomevideoID = heroHomeVideo.data('videoid');
      const heroHomevideoType = heroHomeVideo.data('type');
      const heroHomeVideoOverlay = $('.home-overlay-video');
      console.log(1)
      if(heroHomeVideo) {
        console.log(2)
          let player;
          let playerModal;
          if($('#hero-home-player').length > 0) {
            console.log(3)
              if(heroHomevideoType == 'youtube'){
                  function onYouTubeIframeAPIReady() {
                      playerModal = new YT.Player('playerModal');
                      player = new YT.Player('hero-home-player', {
                          height: '700',
                          width: '100%',
                          videoId: heroHomevideoID,
                          playerVars: {
                              autoplay: 1,
                              modestbranding: 1,
                              showinfo: 0,
                              controls: 0,
                              rel: 0,
                              loop: 1,
                              mute: 1
                          },
                          events: {
                              'onStateChange': onPlayerStateChange,
                              'onReady': onPlayerReady,
                          }
                      });

                      /* player.playVideo(); */
                  }
                
                function onPlayerReady(event) {
                  event.target.playVideo();
                }
      
                  /* function onPlayerStateChange(event) {
                      if (event.data == YT.PlayerState.PAUSED) {
                          homeVideo.removeClass('active')
                      }
                  } */
      
                  heroHomeVideo.find('.btn--cta').click((e) => {
                    e.preventDefault();
                    player.pauseVideo();
                    playerModal.playVideo();
                    heroHomeVideoOverlay.addClass('show-video');
                  });
      
                  const heroHomeVideoOverlayClose = document.querySelector('.close-button-overlay');
                  heroHomeVideoOverlayClose.addEventListener('click', function() {
                    player.playVideo();
                    playerModal.pauseVideo();
                    $('.home-overlay-video').removeClass('show-video');
                  });
              }
      
          }
          /* if($('#playerHtml').length > 0) {
              player = document.getElementById("playerHtml");
      
              player.onpause = function() {
                  homeVideo.removeClass('active');
              };
      
              homeVideo.find('.btn-play').click(() => {
                  homeVideo.addClass('active');
                  player.play();
              });
          } */
      }
      
      
      
      /* heroHomeVideoOverlayClose.click(() => {
        heroHomeVideoOverlay.removeClass('show-video');
      }); */
 
        